var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Button } from "../Button";
import { useHeaderContext } from "./HeaderContext";
var HeaderBrandTop = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "className", "style"]);
    var _b = useHeaderContext(), idSearchBarModal = _b.idSearchBarModal, idMenuModal = _b.idMenuModal, isOpenSearchBar = _b.isOpenSearchBar, setIsOpenSearchBar = _b.setIsOpenSearchBar, isOpenMenu = _b.isOpenMenu, setIsOpenMenu = _b.setIsOpenMenu;
    var handleSearchToggle = function () {
        setIsOpenSearchBar(!isOpenSearchBar);
    };
    var handleMenuToggle = function () {
        setIsOpenMenu(!isOpenMenu);
    };
    var headerBrandTopClass = "fr-header__brand-top";
    if (className) {
        headerBrandTopClass += " ".concat(className);
    }
    var idSearchButton = idSearchBarModal ? idSearchBarModal + "-button" : undefined;
    var idMenuButton = idMenuModal ? idMenuModal + "-button" : undefined;
    return (React.createElement("div", __assign({}, otherProps, { ref: ref, style: style, className: headerBrandTopClass }),
        children,
        (idSearchBarModal || idMenuModal) && (React.createElement("div", { className: "fr-header__navbar" },
            idSearchBarModal && (React.createElement(Button, { className: "fr-btn--search", "data-fr-opened": isOpenSearchBar ? "true" : "false", "aria-controls": idSearchBarModal, id: idSearchButton, title: "Rechercher", onClick: handleSearchToggle }, "Rechercher")),
            idMenuModal && (React.createElement(Button, { className: "fr-btn--menu", "data-fr-opened": isOpenMenu ? "true" : "false", "aria-controls": idMenuModal, id: idMenuButton, title: "Menu", onClick: handleMenuToggle }, "Menu"))))));
});
export default HeaderBrandTop;
